import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/image/plt.svg'


const _withScopeId = n => (_pushScopeId("data-v-6e95f586"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "detail" }
const _hoisted_2 = { class: "detail-title nft-token-title" }
const _hoisted_3 = {
  key: 1,
  src: _imports_0,
  class: "plt-icon"
}
const _hoisted_4 = { class: "s-title" }
const _hoisted_5 = { class: "detail-content" }
const _hoisted_6 = { class: "item first" }
const _hoisted_7 = { class: "title" }
const _hoisted_8 = { class: "content" }
const _hoisted_9 = { class: "text" }
const _hoisted_10 = { class: "item" }
const _hoisted_11 = { class: "title" }
const _hoisted_12 = { class: "content" }
const _hoisted_13 = { class: "text clickable" }
const _hoisted_14 = { class: "copy" }
const _hoisted_15 = {
  id: "detailVal",
  style: {"width":"0","height":"0","opacity":"0"}
}
const _hoisted_16 = { class: "item" }
const _hoisted_17 = { class: "title" }
const _hoisted_18 = { class: "content" }
const _hoisted_19 = { class: "text" }
const _hoisted_20 = { class: "item" }
const _hoisted_21 = { class: "title" }
const _hoisted_22 = { class: "content" }
const _hoisted_23 = { class: "text" }
const _hoisted_24 = { class: "item" }
const _hoisted_25 = { class: "title" }
const _hoisted_26 = { class: "content" }
const _hoisted_27 = {
  class: "text clickable",
  href: "nftInfo.Site"
}
const _hoisted_28 = { class: "detail-list" }
const _hoisted_29 = { class: "tab" }
const _hoisted_30 = { class: "title" }
const _hoisted_31 = { key: 0 }

import { ref, computed, watch } from "vue";
import { useRoute, useRouter } from "vue-router";
import { getNftTokenInfo, getNftTokenTx } from "@/api/_common";
import Title from "@/components/SecondaryTitle.vue";
import Clipboard from "clipboard";
import List from "@/components/List.vue";
import { useMq } from "vue3-mq";
import HelperTools from "@/utils/helper";
import t from "@/utils/en";
import { ElMessage } from "element-plus";
import { ElIcon } from "element-plus";
import { ArrowRight, ArrowLeft, CopyDocument } from "@element-plus/icons";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const routeName = "NFTTokenDetail";
const tabs = ["transfers"];
const pageSize = 10;
const currentPage = ref(0);
const currentTab = ref(tabs[0]);

const nftInfo = ref({
  Token: "",
  Contract: "",
  Owner: "",
  Site: "",
  Profile: {
    image: "",
    name: "",
  },
});
const txs = ref({
  TransactionDetails: [],
  TotalCount: 0,
});

const txRowData = ref([
  {
    prop: "Hash",
    label: "nfttoken.hash",
    method: (row) =>
      `${row.TransactionHash.substr(0, 8)}...${row.TransactionHash.substr(
        58,
        8
      )}`,
  },
  {
    prop: "From",
    label: "nfttoken.from",
    method: (row) => `${row.From.substr(0, 8)}...${row.From.substr(34, 8)}`,
  },
  {
    prop: "To",
    label: "nfttoken.to",
    method: (row) => `${row.To.substr(0, 8)}...${row.To.substr(34, 8)}`,
  },
]);

const isXs = computed(() => useMq().current === "xs");
const parsedContract = computed(() =>
  !nftInfo.value.Contract
    ? ""
    : `${nftInfo.value.Contract.slice(0, 8)}...${nftInfo.value.Contract.slice(
        -8
      )}`
);
const parsedOwner = computed(() =>
  !nftInfo.value.Owner
    ? ""
    : `${nftInfo.value.Owner.slice(0, 8)}...${nftInfo.value.Owner.slice(-8)}`
);

const route = useRoute();
const router = useRouter();

const _getNFTTokenInfo = async () => {
  const params = {
    Contract: route.params.NFT,
    Token: route.params.Token,
  };
  const res = await getNftTokenInfo(params);
  nftInfo.value = res;
};

const _getNFTTokenTxs = async (newPage: number) => {
  const params = {
    Contract: route.params.NFT,
    Token: route.params.Token,
    PageNo: newPage - 1,
    PageSize: pageSize,
  };
  const res = await getNftTokenTx(params);
  txs.value.TotalCount = res.TotalCount;
  txs.value.TransactionDetails = res.TransactionDetails;
};

const setTab = () => {
  if (route.query.tab) {
    currentTab.value = String(route.query.tab);
  }
};

const init = async (page: number) => {
  if (route.query.tab === tabs[0]) await _getNFTTokenTxs(page);
  currentPage.value = page;
};

const load = async () => {
  await _getNFTTokenInfo();
  setTab();
  if (!route.query.page) {
    await router.replace({
      query: {
        page: 1,
        tab: tabs[0],
      },
    });
    await init(1);
  } else {
    await init(Number(route.query.page));
  }
};
load();

watch(
  () => route.query,
  async (n) => {
    if (router.currentRoute.value.name === routeName) {
      init(Number(n.page));
    }
  }
);

const tabSwitch = async (newTab: number) => {
  await router.replace({
    query: {
      page: 1,
      tab: tabs[newTab],
    },
  });
  currentTab.value = tabs[newTab];
};

const handleCurrentChange = async (newPage: number) => {
  await router.replace({
    query: {
      ...route.query,
      page: newPage,
    },
  });
};

const copyDetailVal = () => {
  let clipboard = new Clipboard(".copy-success");
  clipboard.on("success", function (e) {
    e.clearSelection();
  });
  copied();
};
const copied = () => {
  ElMessage(t.message.copysuccess);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (nftInfo.value && nftInfo.value.Profile)
        ? (_openBlock(), _createBlock(Title, {
            key: 0,
            img: nftInfo.value.Profile.image,
            title: nftInfo.value.Profile.name
          }, null, 8, ["img", "title"]))
        : (_openBlock(), _createElementBlock("img", _hoisted_3))
    ]),
    _createElementVNode("div", _hoisted_4, _toDisplayString(_ctx.$t("nfttoken.overview")), 1),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.$t("nfttoken.tokenid")) + ":", 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("span", _hoisted_9, _toDisplayString(nftInfo.value.Token), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.$t("nfttoken.contract")) + ":", 1),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("span", _hoisted_13, _toDisplayString(_unref(isXs) ? _unref(parsedContract) : nftInfo.value.Contract), 1),
          _createVNode(_unref(ElIcon), { size: 16 }, {
            default: _withCtx(() => [
              _createVNode(_unref(CopyDocument), {
                size: 16,
                class: "el-icon-copy-document copy-success",
                "data-clipboard-target": "#detailVal",
                onClick: _cache[0] || (_cache[0] = ($event: any) => (copyDetailVal()))
              })
            ]),
            _: 1
          }),
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", _hoisted_15, _toDisplayString(nftInfo.value.Contract), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.$t("nfttoken.tx")) + ":", 1),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(HelperTools).toFinancialVal(txs.value.TotalCount)), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("nfttoken.owner")) + ":", 1),
        _createElementVNode("div", _hoisted_22, [
          _createElementVNode("span", _hoisted_23, _toDisplayString(_unref(isXs) ? _unref(parsedOwner) : nftInfo.value.Owner), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("div", _hoisted_25, _toDisplayString(_ctx.$t("nfttoken.site")) + ":", 1),
        _createElementVNode("div", _hoisted_26, [
          _createElementVNode("a", _hoisted_27, _toDisplayString(nftInfo.value.Site), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_28, [
      _createElementVNode("div", _hoisted_29, [
        _createElementVNode("div", {
          class: "item",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tabSwitch(0)))
        }, [
          _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.$t("nfttoken.tx")), 1),
          _createElementVNode("div", {
            class: _normalizeClass(currentTab.value === tabs[0] ? 'line active' : 'line')
          }, null, 2)
        ])
      ]),
      (currentTab.value === tabs[0])
        ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
            _createVNode(List, {
              style: {"margin-top":"0","padding":"0"},
              data: txs.value.TransactionDetails,
              handleCurrentChange: handleCurrentChange,
              rowDatas: txRowData.value,
              total: txs.value.TotalCount,
              "current-page": currentPage.value,
              txHashColumn: "0",
              fromColumn: "1",
              toColumn: "2"
            }, null, 8, ["data", "rowDatas", "total", "current-page"])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})